<script lang="ts">
    import type { TPageProperties } from '$src/lib/services/losService/types';

    let { pageProperties }: { pageProperties: TPageProperties } = $props();
    $effect(() => {
        window.fabric.persistedState.preferredWelcomeOffer = pageProperties.preferredWelcomeOffer;
    });
</script>
